export const regexPassword = /(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])/
